/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Facebook Icon
 * @param {https://github.com/adamwathan/entypo-optimized} param0
 */
function Icon({ size, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      width={size}
      height={size}
      {...props}
      fill="currentcolor"
    >
      <path d="M9 10h2v2h9s-.149-4.459-.2-5.854C19.75 4.82 19.275 4 17.8 4h-3.208l-1.197-2.256C13.064 1.121 12.951 1 12.216 1H7.783c-.735 0-.847.121-1.179.744-.165.311-.7 1.318-1.196 2.256H2.199c-1.476 0-1.945.82-2 2.146C.145 7.473 0 12 0 12h9v-2zM7.649 2.916c.23-.432.308-.516.817-.516h3.067c.509 0 .588.084.816.516L12.924 4h-5.85l.575-1.084zM11 15H9v-2H.5s.124 1.797.199 3.322C.73 16.955.917 18 2.499 18H17.5c1.582 0 1.765-1.047 1.8-1.678.087-1.568.2-3.322.2-3.322H11v2z" />
    </svg>
  )
}

Icon.propTypes = {
  size: PropTypes.oneOf([12, 24, 48]).isRequired,
}

const Briefcase = styled(Icon)([], space, color, display)

Briefcase.displayName = 'Briefcase'

Briefcase.defaultProps = {
  size: 24,
}

export default Briefcase
